export async function consumeNDJSONStream(stream, { onEvent, onParseError }) {
  const reader = stream.getReader();
  const decoder = new TextDecoder();
  let buffer = "";

  const flushLine = (line) => {
    const trimmed = line.trim();
    if (!trimmed) return;

    try {
      onEvent(JSON.parse(trimmed));
    } catch (error) {
      onParseError?.(error, trimmed);
    }
  };

  while (true) {
    const { value, done } = await reader.read();

    if (done) {
      buffer += decoder.decode();
      flushLine(buffer);
      break;
    }

    buffer += decoder.decode(value, { stream: true });
    const lines = buffer.split(/\r?\n/);
    buffer = lines.pop() || "";
    lines.forEach(flushLine);
  }
}
